import type { SystemRole } from '@peles/shared';
import { EntityModal } from '../common/EntityModal';
import { isMacPlatform, shortcutHelp } from './shortcuts';

function Key({ children }: { children: string }) {
  return (
    <kbd className="min-w-[1.75rem] h-7 px-1.5 inline-flex items-center justify-center rounded-md border border-gray-300 border-b-2 bg-white text-xs font-semibold text-gray-700">
      {children}
    </kbd>
  );
}

/** The "?" list of keyboard shortcuts, drawn from the same table the keys use. */
export function ShortcutsHelp({
  open,
  onClose,
  role,
}: {
  open: boolean;
  onClose: () => void;
  role: SystemRole | undefined;
}) {
  const groups = shortcutHelp(role, isMacPlatform());
  return (
    <EntityModal open={open} onClose={onClose} title="Keyboard shortcuts" size="sm">
      <div className="space-y-5">
        {groups.map((group) => (
          <section key={group.title}>
            <h3 className="text-xs font-semibold uppercase tracking-wide text-gray-400 mb-2">
              {group.title}
            </h3>
            <dl className="divide-y divide-gray-100">
              {group.rows.map((row) => (
                <div key={row.label} className="flex items-center justify-between gap-4 py-2">
                  <dt className="text-sm text-gray-700">{row.label}</dt>
                  <dd className="flex items-center gap-1 shrink-0">
                    {row.keys.map((k, i) => (
                      <span key={k} className="flex items-center gap-1">
                        {i > 0 && group.title === 'Go to' && (
                          <span className="text-xs text-gray-400">then</span>
                        )}
                        <Key>{k}</Key>
                      </span>
                    ))}
                  </dd>
                </div>
              ))}
            </dl>
          </section>
        ))}
      </div>
    </EntityModal>
  );
}
